/**
 * API functions for practice statistics
 * Uses Swagger-generated API client
 */

import { apiSwagger } from '@/shared/api';
import { StatsSummary, StatsHistoryResponse, CreateStatRequest, CreateStatResponse } from '@/sharedTypes/Api';

export interface StatsHistoryParams {
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  sampleId?: string;
}

/**
 * Fetch stats summary from backend using Swagger API
 * @param accessToken User's access token (not needed, customFetch handles it)
 * @returns Stats summary data
 */
export async function fetchStatsSummary(accessToken: string): Promise<StatsSummary> {
  console.log('[statsApi] Fetching stats summary');

  const response = await apiSwagger.api.statsSummaryList();

  console.log('[statsApi] Stats summary response:', response);

  if (!response.data) {
    throw new Error('Failed to fetch stats summary: no data returned');
  }

  return response.data;
}

/**
 * Fetch stats history from backend using Swagger API
 * @param accessToken User's access token (not needed, customFetch handles it)
 * @param params Optional query parameters
 * @returns Stats history data with pagination
 */
export async function fetchStatsHistory(
  accessToken: string,
  params?: StatsHistoryParams
): Promise<StatsHistoryResponse> {
  console.log('[statsApi] Fetching stats history with params:', params);

  const response = await apiSwagger.api.statsHistoryList(params);

  console.log('[statsApi] Stats history response:', response);

  if (!response.data) {
    throw new Error('Failed to fetch stats history: no data returned');
  }

  return response.data;
}

/**
 * Send practice statistics to backend
 * Called by StatsListener when receiving STATS_SEND event from darpiano-front
 * @param stat The stat data to save (includes sessionId for session-based merging)
 * @returns CreateStatResponse or null on failure
 */
export async function sendStat(stat: CreateStatRequest): Promise<CreateStatResponse | null> {
  console.log('[statsApi] sendStat called with:', stat);

  try {
    const response = await apiSwagger.api.statsCreate(stat);

    console.log('[statsApi] sendStat response:', response);

    if (response.data?.success) {
      console.log('[statsApi] Stat saved successfully, statId:', response.data.statId);
      return response.data;
    } else {
      console.error('[statsApi] Failed to send stat:', response.data?.error || 'Unknown error');
      return null;
    }
  } catch (error) {
    console.error('[statsApi] Exception sending stat:', error);
    return null;
  }
}
